import { render, staticRenderFns } from "./EntityFactList.vue?vue&type=template&id=4f5860fa"
import script from "./EntityFactList.vue?vue&type=script&lang=js"
export * from "./EntityFactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports